export default {
  avatarConfigChanged: "avatarConfigChanged",
  exportAvatar: "exportAvatar",
  resetView: "resetView",
  reactIsLoaded: "reactIsLoaded",
  renderThumbnail: "renderThumbnail",
  thumbnailResult: "thumbnailResult",
  combinedMeshName: "CombinedMesh",
};
